import {
	changeModalProps,
	closeModalTransactionAction,
	openModalAction,
	ServiceList
} from '@bimser/common';
import { integrationTypes } from 'common/components/panelMenu/entities/enums';
import { IMenuItem } from 'common/entities/IMenuItem';
import { call, fork, put, take } from 'redux-saga/effects';
import { setEBA6IntegrationDataAction, setEBA6IntegrationLoadingAction } from '../actions';
import * as ActionTypes from '../actions/actionTypes';

export function* openEBA6IntegrationModal(payload: any) {
	try {
		let resolvePromise: any = null;
		let rejectPromise: any = null;

		const promise = new Promise<any>((resolve, reject) => {
			resolvePromise = resolve;
			rejectPromise = reject;
		});

		yield put(setEBA6IntegrationLoadingAction(true));

		const eBA6Integration = openModalAction({
			type: 'EBA6IntegrationModal',
			id: payload.id,
			visible: true,
			props: { toggleSider: payload.item.toggleSider }
		});

		yield put(eBA6Integration);

		try {
			let response: any,
				item: IMenuItem = payload.item;

			switch (item.parameters.integrationType) {
				case integrationTypes.MyTasks: {
					response = yield ServiceList.workflow.MenuManager.GeteBA6approvalsUrl.call({
						ebaVersion: item.parameters.ebaVersion
					});
					break;
				}
				case integrationTypes.MenuItemKey: {
					response = yield ServiceList.workflow.MenuManager.GeteBA6MenuItemUrl.call({
						menuItemKey: item.parameters.menuItemKey,
						ebaVersion: item.parameters.ebaVersion
					});
					break;
				}
				case integrationTypes.BygoneTasks: {
					response = yield ServiceList.workflow.MenuManager.GeteBA6historyUrl.call({
						menuItemKey: item.parameters.menuItemKey,
						ebaVersion: item.parameters.ebaVersion
					});
					break;
				}
			}

			if (response) {
				const payload = {
					url: response,
					eBAIntegrationHeader: item.parameters.eBAIntegrationHeader
				};
				yield put(setEBA6IntegrationDataAction(payload));
			}
		} catch (error) {
			console.log('eBA6 Integration Exception:', error);
			yield put(closeModalTransactionAction(payload.id));
			yield put(setEBA6IntegrationLoadingAction(false));
		}

		yield fork(waitUserResponse, resolvePromise, rejectPromise, payload.id);

		return yield promise;
	} catch (error) {
		console.log('LOG: function*openEBA6IntegrationModal -> error', error);
	}
}

function* waitUserResponse(resolvePromise: any, rejectPromise: any, id: string) {
	const action = yield take([
		ActionTypes.RESOLVE_EBA6_INTEGRATION_TRANSACTION,
		ActionTypes.REJECT_EBA6_INTEGRATION_TRANSACTION
	]);
	if (
		action &&
		action.type == ActionTypes.RESOLVE_EBA6_INTEGRATION_TRANSACTION &&
		action.payload &&
		action.payload.id == id &&
		resolvePromise
	) {
		yield call(updateModalConfirmLoading, id, true);
		resolvePromise(action.payload.data);
		yield put(closeModalTransactionAction(id));
	} else if (
		action &&
		action.type == ActionTypes.REJECT_EBA6_INTEGRATION_TRANSACTION &&
		rejectPromise
	) {
		yield put(closeModalTransactionAction(id));
		resolvePromise();
	}
}

export function* updateModalConfirmLoading(id: string, data: boolean) {
	yield put(changeModalProps({ id: id, data: { confirmLoading: data } }));
}
